package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.repository.LoadingAddressRepository

/** DELETE /api/v1/loading-addresses/{id} (MIL-99) — routes already created keep their address. */
class DeleteLoadingAddressUseCase(private val repository: LoadingAddressRepository) {
    suspend operator fun invoke(id: String): Result<Unit> = repository.deleteLoadingAddress(id)
}
